<template>
  <div class="form-container card shadow-sm" v-bind="$attrs">
    <div class="header d-flex justify-content-between align-items-center">
      <h4 class="form-title">
        {{ plano.id ? "Editar Prospecção nº " : "Nova Prospecção" }}
        <span v-if="plano.id">
          {{ plano.id }}
        </span>
      </h4>

      <button class="btn btn-secondary btn-sm me-3" @click="voltar">
        Voltar
      </button>
    </div>

    <BaseForm
      :submitText="plano.id ? 'Salvar' : 'Salvar'"
      :cancelText="'Cancelar'"
      :isFormValid="isFormValid"
      :isSubmitting="isSubmitting"
      @submit="salvarPlano"
      @cancel="voltar"
    >

    <!-- FormSection 1: Dados do Responsável -->
    <FormSection title="Dados do responsável">
      <div class="responsavel-grid">
        <div class="campo-contato">
          <InputField
            v-model="plano.nome"
            label="Contato: <span class='required'>*</span>"
            id="nome"
            placeholder="Digite o nome"
            :class="{ 'error-input': errors.nome }"
            required
          />
          <span v-show="errors.nome" class="error-message">
            {{ errors.nome }}
          </span>
        </div>

        <div class="campo-data">
          <InputField
            v-model="plano.data_contato"
            label="Data do contato: <span class='required'>*</span>"
            id="data_contato"
            type="date"
            :class="{ 'error-input': errors.data_contato }"
            required
          />
          <span v-show="errors.data_contato" class="error-message">
            {{ errors.data_contato }}
          </span>
        </div>

        <div class="campo-forma">
          <SelectField
            v-model="plano.forma_contato"
            label="Forma de contato <span class='required'>*</span>"
            id="forma_contato"
            :options="formasContatoOptions"
            :class="{ 'error-input': errors.forma_contato }"
            required
          />
          <span v-show="errors.forma_contato" class="error-message">
            {{ errors.forma_contato }}
          </span>
        </div>

        <div class="campo-ddi">
          <InputField
            v-model="plano.telefone_ddi"
            label="DDI <span class='required'>*</span>"
            id="telefone_ddi"
            placeholder="+55"
            list="ddi-options"
            :class="{ 'error-input': errors.telefone_ddi }"
            required
            @blur="onTelefoneDdiBlur"
          />
          <span v-show="errors.telefone_ddi" class="error-message">
            {{ errors.telefone_ddi }}
          </span>
        </div>

        <div class="campo-telefone">
          <InputField
            v-model="plano.telefone"
            label="Telefone / WhatsApp <span class='required'>*</span>"
            id="telefone"
            placeholder="Digite o telefone"
            :class="{ 'error-input': errors.telefone }"
            required
            @input="onTelefoneInput"
            @blur="validarTelefoneCampo"
          />
          <span v-show="errors.telefone" class="error-message">
            {{ errors.telefone }}
          </span>
        </div>

        <div class="campo-email">
          <InputField
            v-model="plano.email"
            label="Email"
            id="email"
            placeholder="Digite o email"
            :class="{ 'error-input': errors.email }"
          />
          <span v-show="errors.email" class="error-message">
            {{ errors.email }}
          </span>
        </div>

        <div class="campo-como-conheceu">
          <SelectField
            v-model="plano.como_conheceu"
            label="Como Conheceu a escola? <span class='required'>*</span>"
            id="como_conheceu"
            :options="comoConheceuOptions"
            :class="{ 'error-input': errors.como_conheceu }"
            required
          />
          <span v-show="errors.como_conheceu" class="error-message">
            {{ errors.como_conheceu }}
          </span>
        </div>
      </div>

      <datalist id="ddi-options">
        <option
          v-for="ddi in ddiOptions"
          :key="ddi.value"
          :value="ddi.value"
        >
          {{ ddi.label }}
        </option>
      </datalist>
    </FormSection>

      <!-- FormSection 2: Dados do Aluno -->
      <FormSection title="Dados de prospecção do aluno">
        <div class="d-flex align-items-center">
          <InputField
            v-model="plano.nome_aluno"
            label="Nome: <span class='required'>*</span>"
            id="nome_aluno"
            placeholder="Digite o nome do aluno"
            :class="{ 'error-input': errors.nome_aluno }"
            required
            width="300px"
          />
          <span v-show="errors.nome_aluno" class="error-message">
            {{ errors.nome_aluno }}
          </span>
        </div>

        <div class="form-group">
          <label for="ex_aluno">É ex-aluno?</label>
          <div class="form-switch">
            <input
              type="checkbox"
              id="ex_aluno"
              v-model="plano.ex_aluno"
              :true-value="'Sim'"
              :false-value="'Não'"
              class="form-check-input"
            />
            <label for="ex_aluno" class="form-check-label">
              {{ plano.ex_aluno === "Sim" ? "Sim" : "Não" }}
            </label>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <InputField
            v-model="plano.idade"
            type="number"
            label="Idade: <span class='required'>*</span>"
            id="idade"
            placeholder="Digite a idade"
            :class="{ 'error-input': errors.idade }"
            required
          />
          <span v-show="errors.idade" class="error-message">
            {{ errors.idade }}
          </span>
        </div>

        <div class="d-flex align-items-center">
          <SelectField
            v-model="plano.experiencia_com_cavalo"
            label="Possui experiência com cavalo? <span class='required'>*</span>"
            id="experiencia_com_cavalo"
            :options="experienciaCavaloOptions"
            :class="{ 'error-input': errors.experiencia_com_cavalo }"
            required
          />
          <span v-show="errors.experiencia_com_cavalo" class="error-message">
            {{ errors.experiencia_com_cavalo }}
          </span>
        </div>

        <div class="d-flex align-items-center">
          <InputField
            v-if="plano.experiencia_com_cavalo === 'Sim'"
            v-model="plano.qual"
            label="Qual experiência? <span class='required'>*</span>"
            id="qualExperiencia"
            placeholder="Descreva a experiência"
            :class="{ 'error-input': errors.qual }"
            required
          />
          <span v-show="errors.qual" class="error-message">
            {{ errors.qual }}
          </span>
        </div>

        <div class="d-flex align-items-center">
          <InputField
            id="dias_preferencia"
            v-model="plano.dias_preferencia"
            readonly
            placeholder="Selecione os dias"
            label="Dia(s) de preferência <span class='required'>*</span>"
          />
          <button
            type="button"
            class="btn btn-primary pessoa-icon-btn"
            @click="openDiasModal"
          >
            <i class="bi bi-search"></i>
          </button>
        </div>

        <div class="d-flex align-items-center">
          <InputField
            id="turno_preferencia"
            v-model="plano.turno_preferencia"
            readonly
            placeholder="Selecione os turnos"
            label="Turno(s) de preferência  <span class='required'>*</span>"
          />
          <button
            type="button"
            class="btn btn-primary pessoa-icon-btn"
            @click="openTurnosModal"
          >
            <i class="bi bi-search"></i>
          </button>
        </div>

        <div class="d-flex align-items-center" v-if="isNovo">
          <SelectField
            v-model="plano.acao"
            label="Próximo passo: <span class='required'>*</span>"
            id="acao"
            :options="proximoPassoOptions"
            :class="{ 'error-input': errors.acao }"
            :required="isNovo"
          />
          <span v-if="isNovo && errors.acao" class="error-message">
            {{ errors.acao }}
          </span>
        </div>

        <div class="d-flex align-items-center">
          <InputField
            v-model="plano.observacoes"
            label="Observações"
            id="observacoes"
            placeholder="Digite a prospecção inicial"
            width="300px"
          />
        </div>
      </FormSection>
    </BaseForm>
  </div>

  <!-- Modais -->
  <DiasPreferenciaModal
    v-if="diasModalOpen"
    :isOpen="diasModalOpen"
    :initialValue="diasPreferenciaArray"
    @confirm="updateDiasPreferencia"
    @close="diasModalOpen = false"
  />

  <TurnosPreferenciaModal
    v-if="turnosModalOpen"
    :isOpen="turnosModalOpen"
    :initialValue="turnosPreferenciaArray"
    @confirm="updateTurnosPreferencia"
    @close="turnosModalOpen = false"
  />
</template>

<script>
import { reactive, ref, computed, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "@/services/axios";

import InputField from "@/components/Layout/InputField.vue";
import SelectField from "@/components/Layout/SelectField.vue";
import FormSection from "@/components/Layout/FormSection.vue";
import BaseForm from "@/components/Layout/BaseForm.vue";
import DiasPreferenciaModal from "@/components/modals/DiasPreferenciaModal.vue";
import TurnosPreferenciaModal from "@/components/modals/TurnosPreferenciaModal.vue";

export default {
  components: {
    InputField,
    SelectField,
    FormSection,
    BaseForm,
    DiasPreferenciaModal,
    TurnosPreferenciaModal,
  },

  setup() {
    const instance = getCurrentInstance();
    const userName =
      instance?.appContext.config.globalProperties.$globalState.userName || "";

    const router = useRouter();
    const route = useRoute();

    const isNovo = computed(() => !route.params?.id);

    const ddiOptions = [
      { value: "+55", label: "Brasil +55" },
      { value: "+1", label: "EUA/Canadá +1" },
      { value: "+351", label: "Portugal +351" },
      { value: "+54", label: "Argentina +54" },
      { value: "+598", label: "Uruguai +598" },
      { value: "+595", label: "Paraguai +595" },
      { value: "+56", label: "Chile +56" },
      { value: "+39", label: "Itália +39" },
      { value: "+34", label: "Espanha +34" },
      { value: "+49", label: "Alemanha +49" },
    ];

    const formasContatoOptions = [
      { value: "", text: "Selecione" },
      { value: "E-mail", text: "E-mail" },
      { value: "Presencial", text: "Presencial" },
      { value: "Redes sociais", text: "Redes sociais" },
      { value: "Telefone", text: "Telefone" },
      { value: "Site da escola", text: "Site da escola" },
      { value: "WhatsApp", text: "WhatsApp" },
      { value: "Outros", text: "Outros" },
    ];

    const comoConheceuOptions = [
      { value: "", text: "Selecione" },
      { value: "Anúncios online", text: "Anúncios online" },
      { value: "Colônia de férias", text: "Colônia de férias" },
      { value: "Eventos ou competições", text: "Eventos ou competições" },
      { value: "Indicação de alunos", text: "Indicação de alunos" },
      { value: "Indicação de ex-alunos", text: "Indicação de ex-alunos" },
      { value: "Outdoor", text: "Outdoor" },
      { value: "Panfletos", text: "Panfletos" },
      { value: "Parceria", text: "Parceria" },
      { value: "promocao", text: "Promoção" },
      { value: "Redes sociais", text: "Redes sociais" },
      { value: "Site da escola", text: "Site da escola" },
      { value: "Site de buscas", text: "Site de buscas" },
      { value: "Telemarketing", text: "Telemarketing" },
      { value: "Outros", text: "Outros" },
    ];

    const experienciaCavaloOptions = [
      { value: "", text: "Selecione" },
      { value: "Sim", text: "Sim" },
      { value: "Não", text: "Não" },
      { value: "Não informado", text: "Não informado" },
    ];

    const proximoPassoOptions = [
      { value: "", text: "Selecione" },
      { value: "Matrícula", text: "Matrícula" },
      { value: "Agendar aula experimental", text: "Agendar aula experimental" },
      { value: "Agendar próximo contato", text: "Agendar próximo contato" },
    ];

    const plano = reactive({
      id: null,
      nome: "",
      data_contato: "",
      forma_contato: "",
      telefone_ddi: "+55",
      telefone: "",
      email: "",
      como_conheceu: "",
      nome_aluno: "",
      ex_aluno: "Não",
      idade: null,
      exAluno: "",
      experiencia_com_cavalo: "",
      qual: "",
      dias_preferencia: "",
      turno_preferencia: "",
      acao: "",
      observacoes: "",
    });

    const errors = reactive({});
    const isSubmitting = ref(false);

    const normalizarDdi = (valor) => {
      const ddi = (valor || "").toString().trim();

      if (!ddi) return "+55";
      if (/^\d{1,4}$/.test(ddi)) return `+${ddi}`;
      return ddi;
    };

    const limparTelefone = (valor) => {
      return (valor || "").toString().replace(/\D/g, "");
    };

    const formatarTelefoneBrasil = (valor) => {
      const digits = limparTelefone(valor).slice(0, 11);

      if (digits.length <= 2) return digits;
      if (digits.length <= 6) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
      }

      if (digits.length <= 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
      }

      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    };

    const sanitizarTelefoneInternacional = (valor) => {
      return (valor || "")
        .toString()
        .replace(/[^\d\s().-]/g, "")
        .slice(0, 25);
    };

    const validarDdi = (valor) => {
      const ddi = normalizarDdi(valor);
      return /^\+\d{1,4}$/.test(ddi);
    };

    const validarTelefone = () => {
      const ddi = normalizarDdi(plano.telefone_ddi);
      const digits = limparTelefone(plano.telefone);

      if (!validarDdi(ddi)) {
        errors.telefone_ddi = "DDI inválido. Use o formato +55.";
      } else {
        delete errors.telefone_ddi;
      }

      if (!digits) {
        errors.telefone = "Telefone / WhatsApp é obrigatório.";
        return false;
      }

      if (ddi === "+55" && ![10, 11].includes(digits.length)) {
        errors.telefone = "Informe um telefone brasileiro com 10 ou 11 dígitos.";
        return false;
      }

      if (ddi !== "+55" && (digits.length < 6 || digits.length > 15)) {
        errors.telefone = "Informe um telefone internacional com 6 a 15 dígitos.";
        return false;
      }

      delete errors.telefone;
      return !errors.telefone_ddi;
    };

    const onTelefoneInput = (valor) => {
      const ddi = normalizarDdi(plano.telefone_ddi);

      if (ddi === "+55") {
        plano.telefone = formatarTelefoneBrasil(valor);
      } else {
        plano.telefone = sanitizarTelefoneInternacional(valor);
      }

      validarTelefone();
    };

    const onTelefoneDdiBlur = () => {
      plano.telefone_ddi = normalizarDdi(plano.telefone_ddi);

      if (plano.telefone_ddi === "+55") {
        plano.telefone = formatarTelefoneBrasil(plano.telefone);
      } else {
        plano.telefone = sanitizarTelefoneInternacional(plano.telefone);
      }

      validarTelefone();
    };

    const validarTelefoneCampo = () => {
      validarTelefone();
    };

    const isValorSelecionado = (valor) => {
      return !!valor && valor !== "Selecione";
    };

    const isFormValid = computed(() => {
      const telefoneOk = (() => {
        const ddi = normalizarDdi(plano.telefone_ddi);
        const digits = limparTelefone(plano.telefone);

        if (!validarDdi(ddi)) return false;
        if (!digits) return false;

        if (ddi === "+55") return [10, 11].includes(digits.length);
        return digits.length >= 6 && digits.length <= 15;
      })();

      const camposObrigatoriosOk = Boolean(
        plano.nome.trim() &&
          plano.data_contato &&
          isValorSelecionado(plano.forma_contato) &&
          telefoneOk &&
          isValorSelecionado(plano.como_conheceu) &&
          plano.nome_aluno.trim() &&
          plano.idade !== null &&
          Number(plano.idade) > 0 &&
          (plano.experiencia_com_cavalo !== "Sim" ||
            (plano.experiencia_com_cavalo === "Sim" && plano.qual.trim())) &&
          plano.dias_preferencia.trim() &&
          plano.turno_preferencia.trim()
      );

      const proximoPassoOk = !isNovo.value || isValorSelecionado(plano.acao);

      return camposObrigatoriosOk && proximoPassoOk;
    });

    const diasModalOpen = ref(false);
    const turnosModalOpen = ref(false);

    const diasPreferenciaArray = computed(() => {
      if (Array.isArray(plano.dias_preferencia)) {
        return plano.dias_preferencia;
      }

      if (
        typeof plano.dias_preferencia === "string" &&
        plano.dias_preferencia.trim()
      ) {
        return plano.dias_preferencia.split(",").map((item) => item.trim());
      }

      return [];
    });

    const turnosPreferenciaArray = computed(() => {
      if (Array.isArray(plano.turno_preferencia)) {
        return plano.turno_preferencia;
      }

      if (
        typeof plano.turno_preferencia === "string" &&
        plano.turno_preferencia.trim()
      ) {
        return plano.turno_preferencia.split(",").map((item) => item.trim());
      }

      return [];
    });

    function openDiasModal() {
      diasModalOpen.value = true;
    }

    function openTurnosModal() {
      turnosModalOpen.value = true;
    }

    function updateDiasPreferencia(value) {
      plano.dias_preferencia = value;
    }

    function updateTurnosPreferencia(value) {
      plano.turno_preferencia = value;
    }

    const carregarPlano = async () => {
      const id = route.params.id;
      if (!id) return;

      try {
        const response = await axios.get(`/operacional/prospeccao/${id}`);
        const data = response.data;

        if (data.data_contato) {
          data.data_contato = new Date(data.data_contato)
            .toISOString()
            .split("T")[0];
        }

        data.telefone_ddi = normalizarDdi(data.telefone_ddi || "+55");

        if (data.telefone_ddi === "+55") {
          data.telefone = formatarTelefoneBrasil(data.telefone || "");
        } else {
          data.telefone = sanitizarTelefoneInternacional(data.telefone || "");
        }

        data.dias_preferencia = data.dias_preferencia
          ? Array.isArray(data.dias_preferencia)
            ? data.dias_preferencia.join(", ")
            : data.dias_preferencia
          : "";

        data.turno_preferencia = data.turno_preferencia
          ? Array.isArray(data.turno_preferencia)
            ? data.turno_preferencia.join(", ")
            : data.turno_preferencia
          : "";

        data.ex_aluno =
          data.ex_aluno === true || data.ex_aluno === "Sim" ? "Sim" : "Não";

        Object.assign(plano, data);
      } catch (error) {
        console.error("Erro ao carregar plano:", error);
      }
    };

    const salvarPlano = async () => {
      if (isSubmitting.value) return;

      validarTelefone();

      if (!isFormValid.value) {
        console.error("O formulário contém erros:", errors);
        return;
      }

      plano.data_acao = new Date().toISOString().split("T")[0];
      plano.motivo = plano.observacoes;
      plano.usuario = userName;
      plano.telefone_ddi = normalizarDdi(plano.telefone_ddi);

      const isNova = !plano.id;

      if (isNova) {
        plano.classificacao = "Prospect";
      }

      const payload = {
        ...plano,
        telefone_ddi: normalizarDdi(plano.telefone_ddi),
        dias_preferencia: Array.isArray(plano.dias_preferencia)
          ? plano.dias_preferencia.join(",")
          : plano.dias_preferencia,
        turno_preferencia: Array.isArray(plano.turno_preferencia)
          ? plano.turno_preferencia.join(",")
          : plano.turno_preferencia,
      };

      isSubmitting.value = true;

      try {
        const method = isNova ? "post" : "put";
        const url = isNova
          ? "/operacional/prospeccao"
          : `/operacional/prospeccao/${plano.id}`;

        const response = await axios[method](url, payload);

        if (isNova) {
          const novoId = response.data.prospeccao.id;

          if (plano.acao === "Matrícula") {
            router.push(
              `/operacional/prospeccao/${novoId}/detalhar?openMatricula=true`
            );
          } else {
            router.push(
              `/operacional/prospeccao/${novoId}/detalhar?openInteracao=true`
            );
          }
        } else {
          router.push("/operacional/prospeccao");
        }
      } catch (error) {
        console.error("Erro ao salvar prospecção:", error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const voltar = () => {
      router.push("/operacional/prospeccao");
    };

    onMounted(() => {
      carregarPlano();
    });

    return {
      plano,
      ddiOptions,
      formasContatoOptions,
      comoConheceuOptions,
      experienciaCavaloOptions,
      proximoPassoOptions,
      diasModalOpen,
      turnosModalOpen,
      diasPreferenciaArray,
      turnosPreferenciaArray,
      openDiasModal,
      openTurnosModal,
      updateDiasPreferencia,
      updateTurnosPreferencia,
      errors,
      isFormValid,
      isSubmitting,
      salvarPlano,
      voltar,
      isNovo,
      onTelefoneInput,
      onTelefoneDdiBlur,
      validarTelefoneCampo,
    };
  },
};
</script>

<style scoped>
.form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
}

.required {
  color: red;
}

.form-switch {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0.95rem;
  font-size: 0.65rem;
  font-weight: 800;
}

textarea {
  width: 100%;
  resize: none;
  font-size: 1rem;
}

.input-group {
  display: flex;
  gap: 0.5rem;
}

.responsavel-grid {
  display: grid;
  grid-template-columns: 300px 120px 120px 70px 200px;
  column-gap: 16px;
  row-gap: 14px;
  align-items: end;
}

.campo-contato {
  grid-column: 1;
}

.campo-data {
  grid-column: 2;
}

.campo-forma {
  grid-column: 3;
}

.campo-ddi {
  grid-column: 4;
}

.campo-telefone {
  grid-column: 5;
}

.campo-email {
  grid-column: 1;
}

.campo-como-conheceu {
  grid-column: 2 / span 2;
}

@media (max-width: 900px) {
  .responsavel-grid {
    grid-template-columns: 1fr 1fr;
  }

  .campo-contato,
  .campo-data,
  .campo-forma,
  .campo-ddi,
  .campo-telefone,
  .campo-email,
  .campo-como-conheceu {
    grid-column: auto;
  }
}

@media (max-width: 600px) {
  .responsavel-grid {
    grid-template-columns: 1fr;
  }
}
</style>